import { useEffect, useState } from "react";

export function TubeBar({
  height = 209,
  yValue,
  refValue,
  maxYValue,
  color = "#201dbe", // tube fill color
  grooveBaseColor = "#666", // background groove start color
  grooveEdgeColor = "#1a2c3a", // background groove fade-out
  label,
  machine,
  onClick,
}) {
  const handleClick = () => {
    if (onClick) {
      onClick(machine, yValue, refValue, maxYValue, color);
    }
  };

  const barLength = height - 12; // subtract for curvature and padding
  const targetFillLength = (yValue / maxYValue) * barLength;
  const [animatedLength, setAnimatedLength] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimatedLength(targetFillLength);
    }, 50); // slight delay to ensure mount

    return () => clearTimeout(timeout);
  }, [targetFillLength]);

  return machine !== "SPC" ? (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      onClick={handleClick}
    >
      <svg width="23" height={height} viewBox={`0 0 23 ${height}`} fill="none">
        {/* Background Tube */}
        <g filter="url(#filter0_ii_20_37)">
          <rect
            x="3.5"
            y={(height - 5).toString()}
            width={barLength}
            height="16"
            rx="8"
            transform={`rotate(-90 0 ${height - 5})`}
            fill="url(#grad1)"
          />
        </g>
        {/* Fill Tube - rotated horizontally, reversed fill direction */}
        const fillLength = (yValue / maxYValue) * barLength;
        <g filter="url(#filterTubeCartoon)">
          <rect
            x="3.5"
            y={height - 5}
            width={animatedLength}
            height="12"
            rx="6"
            transform={`rotate(-90 3.5 ${height - 5})`}
            fill={`url(#tubeFillGradient-${machine}-${label})`}
            style={{
              transition: "width 1.5s ease-out",
            }}
          />
        </g>
        <defs>
          {/* Background groove gradient */}
          <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={grooveBaseColor} stopOpacity="0.8" />
            <stop offset="100%" stopColor={grooveEdgeColor} stopOpacity="0" />
          </linearGradient>

          {/* Dynamic tube fill gradient (3D effect using input color) */}
          <linearGradient
            id={`tubeFillGradient-${machine}-${label}`}
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.2" />
            <stop offset="40%" stopColor={color} stopOpacity="1" />
            <stop offset="100%" stopColor="#000000" stopOpacity="0.2" />
          </linearGradient>

          {/* Shadow filter for groove */}
          <filter
            id="filter0_ii_20_37"
            x="-5"
            y="-5"
            width="24"
            height={(height + 3).toString()}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="3" dy="3" />
            <feGaussianBlur stdDeviation="2.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
            />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            <feOffset dx="-5" dy="-5" />
            <feGaussianBlur stdDeviation="2.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.23 0 0 0 0 0.27 0 0 0 0 0.32 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_innerShadow"
              result="effect2_innerShadow"
            />
          </filter>

          {/* Gloss + shadow for fill */}
          <filter
            id="filterTubeCartoon"
            x="-3"
            y="-3"
            width="20"
            height={(height + 3).toString()}
            filterUnits="objectBoundingBox"
            colorInterpolationFilters="sRGB"
          >
            {/* <!-- Soft highlight --> */}
            <feOffset dx="-1" dy="-1" result="offsetHighlight" />
            <feGaussianBlur
              in="offsetHighlight"
              stdDeviation="0.8"
              result="blurHighlight"
            />
            <feComposite
              in="blurHighlight"
              in2="SourceAlpha"
              operator="out"
              result="compositeHighlight"
            />
            <feComponentTransfer
              in="compositeHighlight"
              result="componentHighlight"
            >
              <feFuncA type="linear" slope="0.8" />
            </feComponentTransfer>
            <feBlend
              in="componentHighlight"
              in2="SourceGraphic"
              mode="lighten"
              result="blendHighlight"
            />

            {/* <!-- Soft shadow --> */}
            <feOffset dx="1" dy="1" result="offsetShadow" />
            <feGaussianBlur
              in="offsetShadow"
              stdDeviation="1.5"
              result="blurShadow"
            />
            <feComposite
              in="blurShadow"
              in2="SourceAlpha"
              operator="out"
              result="compositeShadow"
            />
            <feComponentTransfer in="compositeShadow" result="componentShadow">
              <feFuncA type="linear" slope="1" />
            </feComponentTransfer>
            <feBlend
              in="componentShadow"
              in2="blendHighlight"
              mode="multiply"
              result="blendShadow"
            />

            {/* <!-- Blend with source --> */}
            <feBlend in="SourceGraphic" in2="blendShadow" mode="normal" />
          </filter>
        </defs>
      </svg>

      <div
        style={{
          color: "#ccc",
          fontSize: "8.5px",
          fontWeight: "700",
          marginBottom: "0.5em",
        }}
      >
        {label}
      </div>
      <div
        style={{
          color: "#aaa",
          fontSize: "8px",
          fontWeight: "200",
          marginBottom: "0",
        }}
      >
        {Math.ceil((yValue / maxYValue) * 100)}
      </div>
      <div
        style={{
          color: "#aaa",
          fontSize: "8px",
          fontWeight: "200",
          marginBottom: "0",
        }}
      >
        {refValue}
      </div>
    </div>
  ) : null;
}
